module.exports = __webpack_public_path__ + "static/media/work-6.2579a1ff.jpg";